import React from 'react';
import PropTypes from 'prop-types';
import './theme/bootstrap.css';
import { Container } from 'mdbreact';
import NotFoundContent from './components/NotFoundContent';
import GlobalStyles from './theme/global-styles';

// Renders a route-not-found message when no route is available from Sitecore
// The JSS equivalent of a 404 Not Found page.

// This is invoked from RouteHandler when Sitecore returns no valid route data.
// The NotFound component receives the Layout Service Context data, but no route data.
// This can be used to power parts of your site, such as navigation, from LS context additions
// without losing the ability to render them on your 404 pages :)

const NotFound = () => (
  <>
    <GlobalStyles />
    <Container>
      <NotFoundContent />
    </Container>
  </>
);

NotFound.propTypes = {
  context: PropTypes.shape({
    site: PropTypes.shape({
      name: PropTypes.string,
    }),
    language: PropTypes.string,
  }),
};

export default NotFound;
